/**
 * Simulator layout interactions: leave modal + sidebar mobile swipe.
 * Mirrors Simulator.vue + Sidebar.vue behaviour.
 */
import { openModal } from "@/shared/modal";

/**
 * Simulator.vue leave confirmation: Modal.vue (partials/modal) opened by the header button;
 * the overlay, the close button and « Continuer ma demande » close it, Escape does not.
 * « Quitter » reloads the vehicle page (Simulator.vue leave(): full reload).
 */
function initLeaveModal(): void {
    const template = document.querySelector<HTMLTemplateElement>('template[data-modal-template="simulation-leave"]');
    const leaveBtn = document.querySelector<HTMLButtonElement>('[data-testid="leave-btn"]');
    if (!template || !leaveBtn) return;

    const leaveUrl = document.querySelector<HTMLElement>('.simulator')?.dataset.leaveUrl ?? '/';

    leaveBtn.addEventListener('click', () => {
        const modal = openModal(template);
        modal.querySelector('[data-attr="simulation-leave-confirm"]')?.addEventListener('click', () => {
            window.location.href = leaveUrl;
        });
    });
}

/**
 * Sidebar.vue: the bar opens (swipe up, click) and closes (swipe down, click) the sidebar on
 * mobile, for a signed-in visitor only (allowSwipe); `-active` on the sidebar and
 * `responsive-footer` on its footer follow isOpen (open at first for a signed-in visitor).
 * setSidebarOpen() is Simulator.vue's forceOpenSidebar (Sidebar.vue forceOpen), used by the résumé.
 */
export function setSidebarOpen(open: boolean): void {
    const sidebar = document.getElementById('simulator-sidebar');
    if (!sidebar) return;
    sidebar.classList.toggle('-active', open);
    sidebar.querySelector<HTMLElement>('.simulator__sidebar__footer > div')?.classList.toggle('responsive-footer', open);
}

function initSidebarSwipe(): void {
    const sidebar = document.getElementById('simulator-sidebar');
    const container = document.getElementById('sidebar-bar-container');
    if (!sidebar || !container || sidebar.dataset.swipe !== '1') return;

    const setOpen = setSidebarOpen;

    // useSwipe: minDiffToActive 15
    let touchStartY = 0;
    container.addEventListener('touchstart', (e: TouchEvent) => {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });
    container.addEventListener('touchend', (e: TouchEvent) => {
        const deltaY = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaY) < 15) return;
        setOpen(deltaY < 0);
    }, { passive: true });

    container.addEventListener('click', () => {
        setOpen(!sidebar.classList.contains('-active'));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initLeaveModal();
        initSidebarSwipe();
    });
} else {
    initLeaveModal();
    initSidebarSwipe();
}
